import { render, staticRenderFns } from "./itemKeypartsDialog.vue?vue&type=template&id=2809721e&scoped=true"
import script from "./itemKeypartsDialog.vue?vue&type=script&lang=js"
export * from "./itemKeypartsDialog.vue?vue&type=script&lang=js"
import style0 from "./itemKeypartsDialog.vue?vue&type=style&index=0&id=2809721e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2809721e",
  null
  
)

export default component.exports